import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";
import { saveWidget, getDashboards, saveDashboard } from "../api/InsightApi";

const api = {
  [ActionTypes.getDashboards]: (workspaceId: string) => getDashboards(workspaceId),
  [ActionTypes.saveDashboard]: (workspaceId: string, dashboard: any) =>
    saveDashboard(workspaceId, dashboard),
  [ActionTypes.addWidget]: (workspaceId: string, dashboardId: string, data) => {
    return saveWidget(workspaceId, dashboardId, data);
  },
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
